import { render, staticRenderFns } from "./view-order.vue?vue&type=template&id=15c43082&scoped=true&"
import script from "./view-order.vue?vue&type=script&lang=js&"
export * from "./view-order.vue?vue&type=script&lang=js&"
import style0 from "./view-order.vue?vue&type=style&index=0&id=15c43082&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c43082",
  null
  
)

export default component.exports